import React from 'react'
import { useField } from 'react-final-form'
import { isEmpty } from 'ramda'
import PropTypes from 'prop-types'
import { useRoute } from 'storfox-route-hooks'
import Box from '@mui/material/Box'

import Button from '../Buttons/Button'
import Dropzone from '../FileUpload/Dropzone'
import { useFileUpload } from '../FileUpload'

function FileUpload ({ className, name, Component, onRemove, setAdditionalData, ...props }) {
  const { removeParams } = useRoute()
  const field = useField(name)

  const value = field.input.value
  const onChange = field.input.onChange

  const onUpload = (data, onProgress) => {
    return props.onUpload(data, onProgress)
      .then(data => {
        onChange(data)
        return data
      })
      .catch(err => Promise.reject(err))
  }

  const [file, handleUpload, setFile] = useFileUpload({ onUpload, setAdditionalData })

  const handleRemove = () => {
    setFile({})
    onRemove()
    onChange(null)
    removeParams('payload')
  }

  return (
    <Box position="relative" className={className}>
      <Box display="flex" justifyContent="flex-end" mb={2}>
        <Button
          onClick={handleRemove}
          disabled={isEmpty(file) && !value}
        >
          Delete
        </Button>
      </Box>
      {(!isEmpty(file) || value) && <Component file={file} information={field.input.value || {}} />}
      {(isEmpty(file) && !value) && <Dropzone onDrop={handleUpload} />}
    </Box>
  )
}

FileUpload.defaultProps = {
  onRemove: () => {}
}

FileUpload.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  onUpload: PropTypes.func.isRequired,
  Component: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  setAdditionalData: PropTypes.func
}

export default FileUpload
